/**
 * Skeleton Variants
 * Common skeleton patterns to reduce duplication
 */

import React from 'react';
import { Skeleton } from './Skeleton';

interface SkeletonTextProps {
  width?: string | number;
  testID?: string;
}

export const SkeletonText: React.FC<SkeletonTextProps> = ({
  width = '100%',
  testID,
}) => <Skeleton width={width as never} height={16} borderRadius={4} testID={testID} />;

interface SkeletonTitleProps {
  width?: string | number;
  testID?: string;
}

export const SkeletonTitle: React.FC<SkeletonTitleProps> = ({
  width = '60%',
  testID,
}) => <Skeleton width={width as never} height={22} borderRadius={4} testID={testID} />;

interface SkeletonBadgeProps {
  width?: number;
  testID?: string;
}

export const SkeletonBadge: React.FC<SkeletonBadgeProps> = ({
  width = 60,
  testID,
}) => <Skeleton width={width} height={24} borderRadius={12} testID={testID} />;

interface SkeletonAvatarProps {
  size?: number;
  testID?: string;
}

export const SkeletonAvatar: React.FC<SkeletonAvatarProps> = ({
  size = 40,
  testID,
}) => (
  <Skeleton width={size} height={size} borderRadius={size / 2} testID={testID} />
);

